"use strict";
/*
 * Created on 04 09 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutSourceImpactValues_1 = require("../../model/sellout/SelloutSourceImpactValues");

var SelloutSourceImpactValuesConverter_1 = require("./SelloutSourceImpactValuesConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSourceImpactValuesConverterImpl =
/*#__PURE__*/
function (_SelloutSourceImpactV) {
  _inherits(SelloutSourceImpactValuesConverterImpl, _SelloutSourceImpactV);

  function SelloutSourceImpactValuesConverterImpl() {
    _classCallCheck(this, SelloutSourceImpactValuesConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSourceImpactValuesConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutSourceImpactValuesConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        validFrom: conversions.fromDate(source.validFrom),
        validTo: source.validTo && conversions.fromDate(source.validTo),
        forecastOldForOneDay: source.forecastOldForOneDay && conversions.fromBigNumber(source.forecastOldForOneDay),
        forecastNewForOneDay: source.forecastNewForOneDay && conversions.fromBigNumber(source.forecastNewForOneDay),
        marginOldUnit: source.marginOldUnit && conversions.fromBigNumber(source.marginOldUnit),
        marginNewUnit: source.marginNewUnit && conversions.fromBigNumber(source.marginNewUnit),
        profitOldUnit: source.profitOldUnit && conversions.fromBigNumber(source.profitOldUnit),
        profitNewUnit: source.profitNewUnit && conversions.fromBigNumber(source.profitNewUnit),
        selloutPrice: source.selloutPrice && conversions.fromBigNumber(source.selloutPrice),
        previousPrice: source.previousPrice && conversions.fromBigNumber(source.previousPrice),
        vatRate: source.vatRate && conversions.fromBigNumber(source.vatRate)
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutSourceImpactValues_1.SelloutSourceImpactValues(conversions.toDate(source.validFrom), conversions.asObjectOpt(source, 'validTo', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'forecastOldForOneDay', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'forecastNewForOneDay', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginOldUnit', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginNewUnit', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitOldUnit', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitNewUnit', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'selloutPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'previousPrice', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'vatRate', function (v) {
        return conversions.toBigNumber(v);
      }));
    }
  }]);

  return SelloutSourceImpactValuesConverterImpl;
}(SelloutSourceImpactValuesConverter_1.SelloutSourceImpactValuesConverter);

exports.SelloutSourceImpactValuesConverterImpl = SelloutSourceImpactValuesConverterImpl;